export const proposedSalaryRegex = /^[1-9]\d*(\.?(\d{1,2})?)?$/;
export const phoneRegex = /^[0-9]*$/;
export const emailRegex = /\S+@\S+\.\S+/;
export const emojisRegex = /<a?:.+?:\d{18}>|\p{Extended_Pictographic}/gu;
